import { render } from "./AddEditShippingPackageModal.vue?vue&type=template&id=508fe38f"
import script from "./AddEditShippingPackageModal.vue?vue&type=script&lang=js"
export * from "./AddEditShippingPackageModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__